(function () {
    let countdownElements = document.querySelectorAll('.countdown-wrapper');
    const second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24;
    let today = new Date();
    countdownElements.forEach(countdownElement => {
      let countdownDate = new Date(countdownElement.querySelector(".countdown").getAttribute('data-countdown-from'));
      const countDown = new Date(countdownDate).getTime(),
        x = setInterval(function() {    
          const now = new Date().getTime(),
                distance = countDown - now;
          countdownElement.querySelector('[data-countdown-id="days"]').innerText = Math.floor(distance / (day)),
          countdownElement.querySelector('[data-countdown-id="hours"]').innerText = Math.floor((distance % (day)) / (hour)),
          countdownElement.querySelector('[data-countdown-id="minutes"]').innerText = Math.floor((distance % (hour)) / (minute)),
          countdownElement.querySelector('[data-countdown-id="seconds"]').innerText = Math.floor((distance % (minute)) / second);
  
          if (distance < 0) {
            document.querySelector(".countdown-wrapper").remove();
            clearInterval(x);
          }
        }, 0)
    
    })
}());